export default __webpack_public_path__ + "static/media/sharerAccounts.4bd875d1.svg";